import styled from 'styled-components';
import { themeGet } from 'styled-system';

const StyledFooter = styled.footer`
  position: relative;
  z-index: 2000;
  width: 100%;
  height: auto;
  min-height: 70px;
  background-color: #2a3744;

  @media (min-width: ${themeGet('breakpoints.md')}px) {
    height: 70px;
  }

  .ca-brand-row {
    display: flex;
    align-items: center;
  }

  .ca-spacer {
    flex-grow: 1;
  }

  .ca-social-list {
    display: flex;
    justify-content: center;

    .ca-social-list-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      margin-right: 6px;
      text-align: center;
      background-color: #9ea9b1;
      color: #2a3744;
      transition: all 0.2s cubic-bezier(0.4, 0, 1, 1);

      &:last-child {
        margin-right: 0;
      }

      & > .fa {
        line-height: 24px;
        font-size: 14px;
      }

      &:hover {
        color: #fff;
      }

      &.facebook:hover {
        background-color: #3a5ba2;
      }
      &.linkedin:hover {
        background-color: #0077b5;
      }
    }
  }

  .ca-copyright {
    font-size: 14px;
    line-height: 1em;
    font-weight: ${themeGet('fontWeights.light')};
    color: #6c8198;
  }

  .ca-contact {
    margin-left: 10px;
    color: #6c8198;
    font-weight: ${themeGet('fontWeights.light')};
    line-height: 20px;
    white-space: nowrap;

    a {
      color: #6c8198;
      text-decoration: none;
    }
  }

  .ca-footer-content--desktop {
    margin: 0;
    padding: 0 10px;
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    flex-shrink: 0;

    .ca-brand-cell,
    .ca-social-cell {
      flex-grow: 0;
    }

    .ca-social-cell {
      width: 33.33333%;
      text-align: center;
    }

    .ca-copyright {
      width: 33.33333%;
      text-align: right;
    }

    .ca-brand-cell {
      display: flex;
      align-items: center;
      width: 33.33333%;
    }
  }

  .ca-footer-content--mobile {
    width: 100%;
    margin: 0 auto;
    padding: 20px 10px 25px 10px;
    justify-content: flex-start;
    flex-direction: column;
    flex-shrink: 0;
  }
`;

export default StyledFooter;
